module.exports = __webpack_public_path__ + "img/armaBoca5.280f98b9.jpg";